import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-14 md:py-16 bg-[#0a0e1a] relative scroll-mt-10" data-id="element-107">
      <div className="max-w-[980px] mx-auto px-4" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-109">
          <h2 className="text-[24px] md:text-[32px] font-black text-white mb-3 uppercase" data-id="element-110">
            🎉 OFERTA POR TIEMPO LIMITADO
          </h2>
          <p className="text-lg md:text-xl text-[#f5a623] font-bold" data-id="element-111">
            Estás a un paso de acceder al KIT SUBLIMACIÓN & DTF VIRAL
          </p>
        </motion.div>

        <div className="flex flex-col md:flex-row justify-center gap-6 max-w-[700px] mx-auto md:items-start" data-id="element-112">
          {/* CARD 1 - PACK ESTÁNDAR */}
          <motion.div initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a1f35] to-[#0a0e1a] rounded-2xl border-2 border-[#f5a623]/50 overflow-hidden flex flex-col max-w-[320px] mx-auto w-full h-fit" data-id="element-113">
            <div className="bg-[#f5a623] text-black text-center py-2 font-black uppercase tracking-wider text-sm" data-id="element-114">
              PACK ESTÁNDAR
            </div>
            <div className="p-5 flex-1 flex flex-col" data-id="element-115">
              {/* Features list */}
              <ul className="space-y-2 mb-4 text-left" data-id="element-116">
                {['+500.000 imágenes virales', 'Categorías populares (anime, autos, terror, memes, etc.)', 'Archivos listos para producción', 'Ahorro brutal de tiempo buscando diseños'].map((item, idx) => <li key={idx} className="flex items-start space-x-2" data-id="element-117">
                    <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-118" />
                    <span className="text-sm text-gray-200" data-id="element-119">{item}</span>
                  </li>)}
              </ul>

              {/* Bonus list */}
              <div className="bg-[#0a0e1a] rounded-lg p-3 mb-5 border border-white/5" data-id="element-120">
                <p className="text-xs font-bold text-[#f5a623] mb-2 uppercase" data-id="element-121">
                  BONUS GRATIS
                </p>
                <ul className="space-y-1.5" data-id="element-122">
                  <li className="text-sm text-gray-300" data-id="element-123">
                    🎁 Almohadones virales (+10.000 diseños)
                  </li>
                  <li className="text-sm text-gray-300" data-id="element-124">
                    🎁 Diseños de tazas (+10.000 diseños)
                  </li>
                  <li className="text-sm text-gray-300" data-id="element-125">🎁 Stickers virales</li>
                </ul>
              </div>

              {/* Price */}
              <div className="text-center mb-1" data-id="element-126">
                <span className="text-gray-400 text-sm line-through decoration-[#ef4444] decoration-2" data-id="element-127">
                  Antes $49.990 ARS
                </span>
              </div>
              <div className="text-center mb-1" data-id="element-128">
                <span className="bg-[#ef4444] text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full uppercase" data-id="element-129">
                  SOLO POR HOY
                </span>
              </div>
              <div className="text-center text-4xl font-black text-[#22c55e] mb-1 text-glow" data-id="element-130">
                $19.990 <span className="text-lg" data-id="element-131">ARS</span>
              </div>
              <p className="text-center text-gray-400 text-sm mb-5" data-id="element-132">
                Hasta en 3 cuotas fijas
              </p>

              <div className="mt-auto" data-id="element-133">
                <a href="https://checkout.kitspremium.online/checkouts/cn/hWN9TW1yPAqVZbbpfUkElRf0/es-ar?_r=AQABZdI4p1-ecgA_m2gKTXz9kl3aFVZbTBWvDPJc3sVQQbI" target="_blank" rel="noopener noreferrer" className="btn-primary w-full block !text-sm !py-3" data-id="element-134">
                  SÍ, QUIERO LA OFERTA AHORA
                </a>
              </div>
            </div>
          </motion.div>

          {/* CARD 2 - ULTRAPACK DELUXE */}
          <motion.div initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a1f35] to-[#0a0e1a] rounded-2xl border-2 border-[#22c55e] overflow-hidden flex flex-col relative md:-translate-y-3 shadow-[0_0_25px_rgba(34,197,94,0.15)] max-w-[320px] mx-auto w-full" data-id="element-135">
            <div className="absolute top-0 right-0 bg-[#ef4444] text-white text-[10px] font-bold px-3 py-0.5 rounded-bl-lg z-10" data-id="element-136">
              MÁS VENDIDO
            </div>
            <div className="bg-[#22c55e] text-black text-center py-2 font-black uppercase tracking-wider text-sm" data-id="element-137">
              ULTRAPACK DELUXE
            </div>
            <div className="p-5 flex-1 flex flex-col" data-id="element-138">
              <img src="https://cdn.magicpatterns.com/uploads/bEb3Zqx8dKCDB3MXjAcb51/d6694a03-add6-4c55-bc04-64a6bcda7d79.png" alt="Ultrapack Deluxe" className="w-full max-w-[220px] h-auto mb-4 drop-shadow-xl mx-auto" data-id="element-139" />

              <p className="text-xs text-center text-[#f5a623] font-bold uppercase mb-2" data-id="element-140">
                ULTRAPACK DELUXE SUBLIMACIÓN & DTF
              </p>
              <p className="text-[13px] text-gray-300 text-center mb-3" data-id="element-141">
                Sistema completo para crear, presentar y vender productos
                personalizados, no solo diseños.
              </p>

              {/* Features */}
              <ul className="space-y-1.5 mb-3 text-left" data-id="element-142">
                {['KIT SUBLIMACION & DTF COMPLETO', '+100.000 diseños organizados en +60 categorías', 'Diseños para remeras, tazas, vasos, barbijos y stickers', 'Mockups profesionales listos para vender', 'Tarjetas de negocio editables', 'Plantillas para catálogos y redes', 'Pack con +120.000 fuentes tipográficas'].map((item, idx) => <li key={idx} className="flex items-start space-x-2" data-id="element-143">
                    <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-144" />
                    <span className="text-[13px] text-gray-200" data-id="element-145">{item}</span>
                  </li>)}
              </ul>

              {/* Sistema para vender */}
              <div className="bg-[#0a0e1a] rounded-lg p-3 mb-4 border border-white/5" data-id="element-146">
                <p className="text-xs font-bold text-[#f5a623] mb-1.5 uppercase" data-id="element-147">
                  Sistema para vender
                </p>
                <ul className="space-y-1" data-id="element-148">
                  {['Guía para vender sin stock', 'Cómo tomar pedidos y cobrar antes de producir', 'Checklist para empezar en 48 horas', 'Actualizaciones constantes', 'Soporte 24/7'].map((item, idx) => <li key={idx} className="flex items-start space-x-2" data-id="element-149">
                      <Check className="w-3.5 h-3.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-150" />
                      <span className="text-[12px] text-gray-300" data-id="element-151">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Savings box */}
              <div className="bg-[#f5a623]/10 border border-[#f5a623]/30 rounded-lg p-2.5 mb-4 text-center" data-id="element-152">
                <p className="text-[12px] text-[#f5a623] font-bold" data-id="element-153">
                  💰 Ahorrás más de $35.000 comprándolo junto
                </p>
              </div>

              {/* Price */}
              <div className="text-center mb-1" data-id="element-154">
                <span className="text-gray-400 text-sm line-through decoration-[#ef4444] decoration-2" data-id="element-155">
                  Antes $59.990 ARS
                </span>
              </div>
              <div className="text-center mb-1" data-id="element-156">
                <span className="bg-[#ef4444] text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full uppercase" data-id="element-157">
                  SOLO POR HOY
                </span>
              </div>
              <div className="text-center text-4xl font-black text-[#f5a623] mb-1 text-glow" data-id="element-158">
                $24.990 <span className="text-lg" data-id="element-159">ARS</span>
              </div>
              <p className="text-center text-gray-400 text-sm mb-5" data-id="element-160">
                Hasta en 3 cuotas fijas
              </p>

              <div className="mt-auto" data-id="element-161">
                <a href="https://checkout.kitspremium.online/checkouts/cn/hWN9TWOpnTlC2hyG6YbK7BSc/es-ar?_r=AQABwjTINrFYx7libuH6r7LxmOJoO27NLKGBn2z9IAXtYFk&preview_theme_id=138042802263" target="_blank" rel="noopener noreferrer" className="btn-primary w-full block !text-sm !py-3 bg-gradient-to-r from-[#f5a623] to-yellow-500 hover:from-yellow-500 hover:to-yellow-400 shadow-[0_0_15px_rgba(245,166,35,0.3)] hover:shadow-[0_0_25px_rgba(245,166,35,0.6)] text-black" data-id="element-162">
                  QUIERO EL ULTRAPACK DELUXE
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}